/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  // --- UI tokens (clean, modern, consistent) ---
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-5";

  // --- Form state ---
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState(null);

  // kept for payload compatibility
  const [fee, setFee] = useState(0);
  const [vip, setVip] = useState(0);
  const [vvip, setVvip] = useState(0);

  const [email, setEmail] = useState(null);
  const [payLink, setPayLink] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");

  const [hashtags, setHashtags] = useState("");

  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);

  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [thingsToDoStatus, setThingsToDoStatus] = useState(1);
  const [expo, setExpo] = useState(0);

  const [description, setDescription] = useState(null);
  const [pricing, setPricing] = useState([]);

  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const thingsToDoRoutes = "/data/things/todo";

  // --- Helpers ---
  const handleText = (setter) => (e) => {
    setter(e.target.value);
    setError(false);
    setSuccess(false);
  };

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setFee(0);
    setVip(0);
    setVvip(0);
    setExpo(0);
    setEmail(null);
    setPayLink(null);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress(null);
    setFeatured(0);
    setDescription(null);
    setPricing([]);
  };

  const responses = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const addOneThingsToDoHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const safeSlug = (t) =>
    t ? t.toLowerCase().trim().replace(/\s+/g, "_") : null;

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: safeSlug(title),
      description: description,
      fee,
      vip,
      vvip,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: thingsToDoStatus,
      featured,
      promoted,
      expo,
      pricing,
    };

    const { status, message } = await createOneContent({
      data,
      content: _TYPES_.THINGSTODO,
    });

    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        {/* Header */}
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>
        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: thingsToDoRoutes }} />
        </div>
        <div className="mb-4">
          <DashboardIntro
            props={{ intro: `Add Things To Do`, name: entry_label }}
          />
        </div>

        {/* Feedback banner */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        </div>

        {/* Form */}
        <form onSubmit={addOneThingsToDoHandler} className="space-y-4">
          {/* Media */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Cover Image" }} />
            <div className="mt-3">
              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={image_kit_folder(country_name, FOLDERS.THINGS_TO_DO)}
              />
            </div>
          </div>

          {/* Details */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Things To Do Details" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-3">
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  required: true,
                  value: title || "",
                  onChange: handleText(setTitle),
                }}
              />
              <InputField
                props={{
                  id: "formatted_address",
                  title: "Formatted Address",
                  type: "address",
                  value: formattedAddress || "",
                  onChange: handleText(setFormattedAddress),
                }}
              />
            </div>
          </div>

          {/* Pricing */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Pricing" }} />
            <div className="mt-3">
              <Pricing pricing={pricing} setPricing={setPricing} />
            </div>
          </div>

          {/* Contact */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-3">
              <div className="flex flex-row justify-center items-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email || "",
                  onChange: handleText(setEmail),
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Social */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Social Contact" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-3">
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp || "",
                  onChange: handleText(setWhatsapp),
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Facebook",
                  type: "text",
                  value: facebook || "",
                  onChange: handleText(setFacebook),
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter || "",
                  onChange: handleText(setTwitter),
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram || "",
                  onChange: handleText(setInstagram),
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube || "",
                  onChange: handleText(setYoutube),
                }}
              />
            </div>
          </div>

          {/* Geo */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Geo Position" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-3">
              <InputField
                props={{
                  id: "google_map_code",
                  title: "Google Map Code",
                  type: "text",
                  value: googleMapCode || "",
                  onChange: handleText(setGoogleMapCode),
                }}
              />
              <InputField
                props={{
                  id: "latitude",
                  title: "Latitude",
                  type: "text",
                  value: latitude || "",
                  onChange: handleText(setLatitude),
                }}
              />
              <InputField
                props={{
                  id: "longitude",
                  title: "Longitude",
                  type: "text",
                  value: longitude || "",
                  onChange: handleText(setLongitude),
                }}
              />
            </div>
          </div>

          {/* More settings */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "More Settings" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-3">
              <Select
                props={{
                  id: "thingsToDo_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  onChange: (e) => {
                    setThingsToDoStatus(e.target.selectedIndex === 0 ? 1 : 0);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
              <Select
                props={{
                  id: "featured",
                  title: "Featured",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setFeatured(e.target.value);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    const choice = e.target.value;
                    setExpo(choice === "no" ? 0 : 1);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
            </div>
          </div>

          {/* Description */}
          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-col gap-3">
              <div>
                <MyButton
                  onClick={() => setShowDescriptionModal(true)}
                  className="bg-blue-700 py-3"
                >
                  Generate Description
                </MyButton>
              </div>
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description || "",
                  onChange: handleText(setDescription),
                }}
              />
            </div>
          </div>

          {/* Tags + Submit */}
          <div className={`${card} ${sectionPad}`}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags || "",
                  onChange: handleText(setHashtags),
                }}
              />
            </div>

            <div className="pt-4">
              <MyActionButton
                loading={loading}
                title="Add Things To Do"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>

      {/* Description modal */}
      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}
    </div>
  );
};

export default Add;
